import React, { useState } from "react";
import { Grid, Typography, Paper } from '@mui/material';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Box from "@mui/material/Box";
import { useAuth } from '../hooks/useAuth';

export default function PaypalComp({ eventData, setSuccess, payloadData }) {    
    const { accessToken, signOut } = useAuth();
    const API_URL = process.env.REACT_APP_API_URL;
    const [paymentData, setPaymentData] = useState(eventData);
    console.log("Event data in Paypal comp before :", eventData, paymentData, payloadData);
    /*
    async function sendToServer() {
        console.log("transaction after Paypal payment:", membershipData);

        try {
            const response = await fetch(`${API_URL}/memberships`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "x-cmdfw-jwt-token": `${accessToken}`,
                },
                body: JSON.stringify(membershipData),
            });
            console.log('API response:', response.data);            
        } catch (error) {
            console.error('Error:', error);
            return false;
        }
        return true;
    } */
    async function sendToServer() {
        console.log("transaction after paypal payment inside sendToServer :", payloadData);
        const maxRetries = 3; // Maximum number of retries
        let attempt = 0;

        while (attempt < maxRetries) {
            try {
            //const url = process.env.REACT_APP_SQS_URL;
            const response = await fetch(`${API_URL}/events`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "x-cmdfw-jwt-token": `${accessToken}`,
                },
                body: JSON.stringify(payloadData),
            });
            //console.log('API response:', response.data);
            if (response.ok) {
                return true; // Success
            }
            if (response.status === 403) {
                const errorData = await response.json();
                //handleLogout(); // Logout user
                throw new Error(errorData.message || 'OTP expired');
              } else {
                const errorData = await response.json();
                console.error('API Error:', errorData);
                //setError(errorData.message);
                return false; // API call failed
                //throw new Error(errorData.message || 'API call failed');
            }
        } catch (error) {
            console.error(`Attempt ${attempt + 1} failed:`, error);
            attempt++;

            if (attempt >= maxRetries) {
                console.error('All retry attempts failed.');
                //setError("Failed to send data to the server. Please try again later.");
                return false; // Return false after all retries fail
            }

            console.log(`Retrying API call... (${attempt}/${maxRetries})`);
 
        }
    }
    }

    const initialOptions = {
        clientId: process.env.REACT_APP_PROD_CLIENT_ID,
        currency: "USD",
        intent: "capture",
        "disable-funding": "paylater"
    };

    const [errorMessage, setErrorMessage] = useState('')
    const [orderId, setOrderId] = useState(false)

    const createOrder = (data, actions) => {
        var itemArray = [];

        if (paymentData.transaction.quantities > 0) {
            itemArray[itemArray.length] = {
                name: paymentData.eventType,
                description: paymentData.eventType,
                unit_amount: {
                    currency_code: "USD",
                    value: "" + parseInt(paymentData.transaction.itemPrice * paymentData.transaction.quantities),
                },
                quantity: "1",
            }
        }
        console.log('items array donation:', paymentData.transaction.donationAmount);
        if (paymentData.transaction.donationAmount > 0) {
            itemArray[itemArray.length] = {
                name: "Donation Amount",
                description: "Donation item",
                unit_amount: {
                    currency_code: "USD",
                    value: paymentData.transaction.donationAmount,
                },
                quantity: "1",
            }
        }
        console.log('items array fee:', paymentData.feeEnabled);
        if (paymentData.feeEnabled > 0) {
            itemArray[itemArray.length] = {
                name: "Credit Card processing Fee Amount",
                description: "Credit Card Fee item",
                unit_amount: {
                    currency_code: "USD",
                    value: ((parseInt(paymentData.transaction.quantities) * paymentData.transaction.itemPrice + parseInt(paymentData.transaction.donationAmount)) * 0.03).toFixed(2),
                },
                quantity: "1",
            }
        }
        console.log('items array in create order 2:', itemArray, paymentData.transaction.totalAmount, paymentData.transaction.donationAmount);
        return actions.order.create({
            purchase_units: [
                {
                    description: paymentData.eventType,
                    amount: {
                        value: paymentData.transaction.totalAmount,
                        currency_code: "USD",
                        breakdown: {
                            item_total: {
                                value: paymentData.transaction.totalAmount,
                                currency_code: "USD",
                            }
                        }
                    },

                    items: itemArray, /**/
                },
            ],
            payer: {
                name: {
                given_name: paymentData.parent.firstName, // First Name from the form
                surname: paymentData.parent.lastName // Last Name from the form
                },
                email_address: paymentData.parent.email, //paymentData.parent.email,
                phone: {
                phone_type: "MOBILE",  // Specify it's a mobile number
                phone_number: {
                    national_number: paymentData.parent.mobileNumber  // Mobile number
                }
                },
            }
        })
            .then((orderId) => {
                setOrderId(orderId)
                return orderId
            })
    }
    const onApprove = (data, actions) => {
        return actions.order.capture().then(function (details) {
            const { payer } = details
            console.log('Payer info : ', payer, paymentData.transaction.paymentStatus);  
            setSuccess(true);
            paymentData.status = 'paid';
            paymentData.transaction.payerId = payer.payer_id;
            ///setpaymentData(paymentData);
            console.log('Payer info : ', payer);
            console.log('on Approve Event data in payment comp : ', paymentData);
            sendToServer();
        })
    }
    const onError = (data, actions) => {
        console.log('An error with Paypal approve Event data : ', paymentData, data, actions);
        setErrorMessage("An error occured with your payment")
    }

    return (
        <div>
                <Grid container direction="column" alignItems="center" >
                    {                     
                                <Grid item>                         
                                    <span>
                                        <Box sx={{ width: '100%', maxWidth: 500 }}>
                                            <Typography variant="h6" align="left" gutterBottom>
                                                <b>If you want make any changes, please click "Back" button otherwise click "Paypal"
                                          button to complete the transactions.</b>
                                                <div><br /></div>
                                                <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'red', fontWeight: 'bolder' }} elevation={3}>
                                            NOTE: if you don't see PayPal buttons, please use Chrome browser (or) Laptop (or) contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a></Paper>
                                          <div><br /></div>
                                            </Typography>
                                        </Box>
                                    </span>
                                    <PayPalScriptProvider options={initialOptions}>
                                        <PayPalButtons style={{ layout: "vertical", label: "pay" }}
                                            createOrder={createOrder}
                                            onApprove={onApprove}
                                        />
                                    </PayPalScriptProvider>                              
                                </Grid>}
                </Grid>
        </div >
    );
}